import React from 'react';
import "./index.css";
import "./mobile.css";
import { blogContent } from '../../random-stored-js/blogs';

function Collection({left,top,zIndex,indexNumber,collection, imageSource,heading,closeFunction,moveFunction,upFunction,downFunction,functionToAdd,bodySizing}) {
    const getTableHeaders = () => {
        return ["Name","Date Added"];
    }

    const openNewDoc = (e) => {
        let targetFile = e.target.innerHTML;
        if(heading==="Documents.doc"){
            let getTargetFileDirection = "./images/documents/" + targetFile;
            const newBox = {type:"dialog",heading:targetFile,headingImageSource:"./images/programs/pictures.png",left:0.4,top:0.2,bodyImageSource:getTargetFileDirection,bodyButtonText:false,bodyText:false};
            functionToAdd(newBox);
        }
        if(heading==="Blogs.doc"){
            const newBox = {type:"blog",heading:targetFile,headingImageSource:"./images/programs/blog.png",left:0.4,top:0.2,content:blogContent[targetFile]};
            functionToAdd(newBox);
        }
    }
    // Render table headers
    const renderTableHeaders = () => {
        const headers = getTableHeaders();
        return headers.map(header => <th className='bordered' key={header}>{header}</th>);
    }

    // Render table rows
    const renderTableRows = () => {
        return collection.map((item, index) => (
            <tr key={index}>
                {getTableHeaders().map((header, headerIndex) => (
                    <td 
                        key={`${index}-${header}`}
                        onClick={headerIndex === 0 ? openNewDoc : ""}
                        className={headerIndex === 0 ? "first-item-in-row" : ""}

                    >
                        {item[header] || ''}
                    </td>
                ))}
            </tr>
        ));
    }
return <div className="dialog-box collection" id={indexNumber} 
style={{ left: left, 
    top: top, 
    zIndex:zIndex
}}
onMouseMove={moveFunction}
onMouseUp={upFunction}
data-boxindex={indexNumber}
>
    <div className="dialog-box-heading big-text draggable-box"
     onMouseDown={downFunction}
     data-boxindex={indexNumber}
    >
        <div className="dialog-box-info draggable-box" data-boxindex={indexNumber}>
            <img className="heading-image draggable-box" src={imageSource} alt="heading" data-boxindex={indexNumber}/>
            <div className='draggable-box' data-boxindex={indexNumber}>{heading}</div>
        </div>
        <img className="close-button" src="./images/UI/close.png" alt="close button" onClick={()=>{closeFunction(indexNumber)}} />
    </div>
    <div className="dialog-box-body small-text collection-body">
    <table className='collection-table'>
                    <thead>
                        <tr>{renderTableHeaders()}</tr>
                    </thead>
                    <tbody>
                        {renderTableRows()}
                    </tbody>
                </table>
    </div>
</div>
}
export default Collection;
